import * as React from "react";
import { Users } from "./UsersPage";

type Props = {};

const UsersPage = (props: Props) => {
	return <Users />;
};

export default UsersPage;
